import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Heading from 'components/Heading'
import Button from 'components/Button'

import { TextField, EmailField, PasswordField } from 'components/Fields'

import RightArrow from 'public/icons/rightarrow.svg'

import styles from '../Signup.module.css'

const CreateAccountForm = (props) => {
  const {
    formField: { firstName, lastName, email, password },
  } = props

  async function submit() {
    await props.setFieldValue('step', 'account')
    props.handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        Create Your TITANS of CNC Account
      </Heading>
      <div className={styles['create-account-wrapper']}>
        <div className={styles['signup-fields']}>
          <div className={styles['signup-field-name']}>
            <TextField name={firstName.name} label={firstName.label} className={styles['signup-input']} />
            <TextField name={lastName.name} label={lastName.label} className={styles['signup-input']} />
          </div>
          <div className={styles['signup-field-email']}>
            <EmailField name={email.name} label={email.label} className={styles['signup-input']} />
          </div>
          <div className={styles['signup-field-password']}>
            <PasswordField name={password.name} label={password.label} className={styles['signup-input']} />
          </div>
        </div>

        <div className={styles['form-footer']}>
          <Button
            onClick={submit}
            primary
            centered
            disabled={props.isSubmitting}
            spinner={props.isSubmitting}
            icon={<RightArrow />}
          />
        </div>
      </div>
    </div>
  )
}

export default CreateAccountForm
